// @flow
/* eslint-disable import/prefer-default-export */
import { PERMISSIONS } from 'common/constants';

import * as t from './types';

type Permission = string | string[];

type Route = { path: string, permissions: ?Permission };

export type RouteMap = { [key: string]: Route };

function mergePermissions(a, b) {
  if (a && b) {
    // maybe need add AND operation?
    return [].concat(a).concat(b);
  } else if (a) {
    return a;
  } else if (b) {
    return b;
  }

  return null;
}

function route(path: string, permissions: ?Permission = null): Route {
  return { path, permissions };
}

function group(prefix: string, permissions: ?Permission, routes: RouteMap): RouteMap {
  return Object.keys(routes).reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        ...routes[key],
        path: `${prefix}${routes[key].path}`,
        permissions: mergePermissions(permissions, routes[key].permissions),
      },
    }),
    {},
  );
}

export default {
  [t.AUTH_ACTIVATE]: route('/activate', PERMISSIONS.GUEST_ACCESS),
  [t.AUTH_LOGIN]: route('/sign-in', PERMISSIONS.GUEST_ACCESS),
  [t.AUTH_LOGOUT]: route('/sign-out'),
  [t.AUTH_REGISTER]: route('/sign-up', PERMISSIONS.GUEST_ACCESS),

  ...group('/crm', null, {
    [t.ADVERTISER_LIST]: route('/advertisers', PERMISSIONS.INDEX_ADVERTISER),
    ...group('/advertisers/:id', PERMISSIONS.SHOW_ADVERTISER, {
      [t.ADVERTISER_VIEW]: route(''),
      [t.ADVERTISER_VIEW_BALANCE]: route('/balance'),
      [t.ADVERTISER_VIEW_BILLING_INFO_EMPTY]: route(
        '/billing-info/',
        PERMISSIONS.BILLING_EDIT_BILLING_INFO_ADVERTISER,
      ),
      [t.ADVERTISER_VIEW_BILLING_INFO]: route(
        '/billing-info/:currency',
        PERMISSIONS.BILLING_EDIT_BILLING_INFO_ADVERTISER,
      ),
      [t.ADVERTISER_VIEW_USER_LIST]: route('/users'),
      [t.ADVERTISER_VIEW_VOUCHER_LIST]: route('/vouchers'),
    }),

    [t.AMI_LIST]: route('/amis', PERMISSIONS.INDEX_AMI),

    [t.CRM_HOME]: route(''),

    [t.DOMAIN_LIST]: route('/domains', PERMISSIONS.SAFEPAGES_LIST_DOMAIN),
    ...group('/domains/:id', PERMISSIONS.SAFEPAGES_SHOW_DOMAIN, {
      [t.DOMAIN_VIEW]: route(''),
      [t.DOMAIN_VIEW_PRELAND]: route('/preland'),
      [t.DOMAIN_VIEW_SAFEPAGE]: route('/safepage'),
    }),
    [t.DOMAIN_CONFIRM_CHANGES]: route('/domain-confirm-changes'),

    [t.MODEM_LIST]: route('/modems', PERMISSIONS.INDEX_CONNECTOR_BOX),

    [t.MY_ACCOUNT]: route('/my-account'),
    [t.MY_ACCOUNT_BALANCE]: route('/my-account/balance'),
    [t.MY_ACCOUNT_BILLING_INFO_EMPTY]: route(
      '/my-account/billing-info',
      PERMISSIONS.BILLING_EDIT_BILLING_INFO_ADVERTISER_OWN,
    ),
    [t.MY_ACCOUNT_BILLING_INFO]: route(
      '/my-account/billing-info/:currency',
      PERMISSIONS.BILLING_EDIT_BILLING_INFO_ADVERTISER_OWN,
    ),
    [t.MY_ACCOUNT_USER_LIST]: route('/my-account/users'),
    [t.MY_ACCOUNT_VOUCHER_LIST]: route('/my-account/vouchers'),

    [t.PAYMENT_LIST]: route('/payments', PERMISSIONS.INDEX_PAYMENTS),

    [t.RECORD_LIST]: route('/sessions-log', [
      PERMISSIONS.INDEX_PROFILE_SESSION,
      PERMISSIONS.INDEX_MANAGED_PROFILE_SESSION,
    ]),

    [t.AUTOSTART_SESSIONS]: route('/autostart-sessions', [PERMISSIONS.INDEX_AUTOSTART_SESSIONS]),
    [t.AUTO_FARMING]: route('/auto-farming', [PERMISSIONS.INDEX_AUTOSTART_SESSIONS]),

    [t.PRELAND_LIST]: route('/prelands', PERMISSIONS.SAFEPAGES_LIST_PRELANDING),
    [t.PRELAND_VIEW]: route('/prelands/:id', PERMISSIONS.SAFEPAGES_SHOW_PRELANDING),
    [t.PRELAND_VIEW_SOURCE]: route('/prelands/:id/source', PERMISSIONS.SAFEPAGES_SHOW_PRELANDING),

    [t.PROFILE_LIST]: route('/profiles', PERMISSIONS.INDEX_PROFILE),
    ...group(
      '/profiles/:id',
      [
        PERMISSIONS.SHOW_PROFILE_ANY,
        PERMISSIONS.SHOW_PROFILE_OWN,
        PERMISSIONS.SHOW_PROFILE_MANAGED,
        PERMISSIONS.SHOW_PROFILE_FREE,
      ],
      {
        [t.PROFILE_VIEW]: route(''),
        [t.PROFILE_VIEW_FACEBOOK]: route('/facebook'),
        [t.PROFILE_VIEW_GOOGLE]: route('/google'),
        [t.PROFILE_VIEW_PAYPAL]: route('/paypal'),
        [t.PROFILE_VIEW_DOMAIN]: route('/domain'),
        [t.PROFILE_VIEW_PRELAND]: route('/preland'),
        [t.PROFILE_VIEW_SAFEPAGE]: route('/safepage'),
      },
    ),

    [t.USER_LIST]: route('/users', PERMISSIONS.INDEX_USER),

    [t.VOUCHER_LIST]: route('/vouchers', [
      PERMISSIONS.BILLING_INDEX_ALL_VOUCHERS,
      PERMISSIONS.BILLING_INDEX_OWN_VOUCHERS,
    ]),

    [t.STATS]: route('/stats', PERMISSIONS.BILLING_INDEX_PRODUCT_STATS),
    [t.REFERRAL_STATS]: route(
      '/referral-stats',
      PERMISSIONS.BILLING_INDEX_PRODUCT_STATS_WITH_OWN_VOUCHERS,
    ),
  }),

  [t.FORBIDDEN]: route('/403'),
  [t.NOT_FOUND]: route('/404'),

  [t.PAGE_PRIVACY_POLICY]: route('/privacy-policy'),
  [t.PAGE_TERMS_AND_CONDITIONS]: route('/terms-and-conditions'),
  [t.ROOT]: route('/'),
};



// WEBPACK FOOTER //
// ./src/modules/router/routes.js